import { ComplexStyleRule, style, styleVariants } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const containerStyles = style({
  position: "relative",
});

const baseStyles: ComplexStyleRule = {
  display: "flex",
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.surface,
  padding: `${vars.space.m} 0`,
  overflow: "auto",
  color: vars.colors.onSurface,
};

export const statListStyles = styleVariants({
  default: {
    ...baseStyles,
  },
  scroll: {
    ...baseStyles,
    maskImage:
      "linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)",
    maskRepeat: "no-repeat",
    maskSize: "100% 100%",
    maskMode: "match-source",

    WebkitMaskImage:
      "linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)",
    WebkitMaskRepeat: "no-repeat",
    WebkitMaskSize: "100% 100%",
    /* WebkitMaskMode not yet added to cssType declarations
    https://github.com/vanilla-extract-css/vanilla-extract/discussions/740 */
    WebkitMaskMode: "match-source",
    selectors: {
      '[dir="rtl"] &': {
        maskImage:
          "linear-gradient(to left, transparent 0%, black 5%, black 95%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to left, transparent 0%, black 5%, black 95%, transparent 100%)",
      },
    },
  } as ComplexStyleRule,
});

export const iconContainer = style({
  position: "absolute",
  zIndex: 5,
  alignContent: "center",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
});

const iconBase = style({
  position: "absolute",
  transform: "translate(0%, -50%)",
  width: 12,
  height: 12,
});

export const chevronLeftStyles = style([
  iconBase,
  {
    left: 0,
    marginLeft: 4,
  },
]);

export const chevronRightStyles = style([
  iconBase,
  {
    insetInlineEnd: 0,
    marginInlineEnd: 4,
  },
]);
